import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  api: string = environment.apiEndPoint;

  constructor(
              private http: HttpClient
            ) { }

  login(userName: any, password: any) { 
    return this.http.post(this.api + '/Auth/Login', {
      userName,
      password,
      application: environment.application,
      version: environment.version
    });
  }
}
